import { render } from "./PMyCustomers.vue?vue&type=template&id=727b6784&scoped=true"
import script from "./PMyCustomers.vue?vue&type=script&lang=js"
export * from "./PMyCustomers.vue?vue&type=script&lang=js"

import "./PMyCustomers.vue?vue&type=style&index=0&id=727b6784&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727b6784"]])

export default __exports__